/**
 * @class
 */
import Base from 'netxcore@netx/core-app/views/appModalCrumbView';

import {faTimes} from '@fortawesome/pro-solid-svg-icons';
const icons = Base.initializeIcons({
	faTimes,
});

export default class AppModalCrumbView extends Base {
	/** @override */
	constructor(opts = {}) {
		const model = opts.model;
		const active = model.get('active');
		const index = model.collection.indexOf(model);

		opts.tagName = 'button';
		opts.className = `mdc-tab ${
			active || !index ? 'mdc-tab--active' : ''
		} nx-action`;
		opts.attributes = {
			'data-action': model.get('uniqueShowAction'),
			'aria-selected': active || !index,
			role: 'tab',
			'data-nx-tab-name': model.get('name'),
			tabindex: active || !index ? 0 : -1,
		};
		opts.icons = {...icons, ...opts.icons};
		super(opts);
	}

	/** @override */
	preRender() {
		super.preRender();

		const model = this.model;
		Object.assign(this.templateVars, {
			index: (model.collection && model.collection.indexOf(model)) || 0,
		});
	}

	/** @method */
	toggleActive() {
		super.toggleActive();

		const active = this.model.get('active') === true;
		this.el.classList.toggle('mdc-tab--active', active);
		this.el.setAttribute('aria-selected', active);
		this.el
			.querySelector('.mdc-tab-indicator')
			.classList.toggle('mdc-tab-indicator--active', active);
	}
}
